import { useEffect, useState } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import Image from "next/legacy/image"
import { DfAvatarLogin, QrcodeOnlus } from "components/ui/Icons"
import cn from "classnames"
import s from "./Navbar.module.css"
import Cookies from "js-cookie"

export default function NavbarMobile({ listMenus, isNav, setIsNav }) {
  const { userInfo, togleModalLogin } = useStore()
  const { avatar, fullname } = userInfo
  const router = useRouter()
  function onChangeModal() {
    togleModalLogin()
  }
  const [defaultAvatar, setDefaultAvatar] = useState(
    "https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png"
  )

  useEffect(() => {
    setDefaultAvatar(avatar)
  }, [avatar])

  useEffect(() => {
    if (isNav) {
      if (document.body.style.overflow !== "hidden") {
        document.body.style.overflow = "hidden"
      }
    }
    return () => {
      document.body.style.overflow = null
      document.body.style.width = null
    }
  }, [isNav])

  const wapperClass = isNav ? "show__sider--mobile" : "hide__sider--mobile"

  return (
    <div
      className={`bg-dark-900 z-40 inset-0 fixed text-slate-400 p-6 h-screen border-r border-slate-700 shadow ease-in-out duration-300 ${wapperClass} w-full`}
    >
      <div className="flex flex-col justify-between h-full">
        <div>
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center">
              {Cookies.get("accessToken") || Cookies.get("refreshToken") ? (
                <div
                  className=""
                  onClick={() => {
                    setIsNav(false)
                  }}
                >
                  <Link href="/PopupProfile" key={1}>
                    <div className="flex gap-4 items-center">
                      {avatar ? (
                        <Image
                          className="rounded-full cursor-pointer"
                          objectFit="contain"
                          width={40}
                          height={40}
                          src={defaultAvatar || "https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png"}
                          onError={() =>
                            setDefaultAvatar("https://stvinaprod.vtvcab.vn/98617bf4-240e-4b4f-a884-a7912c7d1c52.png")
                          }
                        />
                      ) : (
                        <div>{fullname ? DfAvatarLogin : DfAvatar}</div>
                      )}
                      <div>
                        <div className="text-md text-dark-100">{fullname}</div>
                        <div className="text-sm">Xem thông tin cá nhân</div>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : (
                <div className="flex items-center gap-3">
                  <div
                    className="flex items-center"
                    onClick={onChangeModal}
                    role="button"
                    tabIndex="0"
                    onKeyDown={onChangeModal}
                  >
                    {login}
                  </div>
                  <div>
                    <div className="text-md text-dark-100">Tài khoản</div>
                    <div className="text-sm">Khách</div>
                  </div>
                </div>
              )}
            </div>

            <button
              onClick={() => {
                setIsNav(false)
              }}
              className={""}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          {(!Cookies.get("accessToken") || !Cookies.get("refreshToken")) && (
            <button
              onClick={onChangeModal}
              className="rounded-xl w-full text-white py-2 px-8 text-lg mb-4 space-x-4 hover:bg-primary-hover bg-primary-500 font-semibold"
            >
              Đăng nhập
            </button>
          )}
          <div>
            <div className="flex flex-col mt-6">
              <div className="">
                {listMenus.map((item, key) => {
                  const { path, title, icon } = item
                  const activeClassName = router.pathname === path ? "bg-white/20 text-slate-200" : "text-slate-400"
                  return (
                    <div key={key} className="mb-2">
                      {title === "Tin tức" ? (
                        <a href={path} target="__blank">
                          <div className={`${activeClassName} menu__item hover:bg-white/20`}>
                            {icon}
                            <span className="text-ellipsis flex-auto overflow-hidden whitespace-nowrap">{title}</span>
                          </div>
                        </a>
                      ) : (
                        <Link href={path}>
                          <div
                            className={`${activeClassName} menu__item hover:bg-white/20`}
                            onClick={() => {
                              setIsNav(false)
                            }}
                          >
                            {icon}
                            <span className="text-ellipsis flex-auto overflow-hidden whitespace-nowrap relative">
                              {title}
                              {title === "Esports" && (
                                <span
                                  className={cn({
                                    [s.animationTextMobile]: title === "Esports"
                                  })}
                                >
                                  HOT
                                </span>
                              )}
                            </span>
                          </div>
                        </Link>
                      )}
                    </div>
                  )
                  // }
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto">
          <div className="grid sm:grid-cols-12 gap-2 sm:gap-4">
            <div className="col-span-8">
              <div className="hidden mb-4 md:block">
                <Link href="/">
                  <div className="flex gap-4 items-center">
                    <img src="/logo/logo-wc.png" width={74} height={74} alt="xx" />
                    {/* Logo thường: */}
                    {/* <img src="/logo/logo.png" width={74} height={74} alt="xx" /> */}
                    <div className="min-w-[3px] bg-slate-400 h-16"></div>
                    <div className="text-2xl text-dark-100 font-medium">vinaphone</div>
                  </div>
                </Link>
              </div>
              <p className="mb-4 mt-2 text-sm text-justify" style={{ maxWidth: 500 }}>
                Ứng dụng xem trực tiếp thể thao, bóng đá.
              </p>
              <div className="flex space-x-4 items-center">
                <div className="cursor-pointer">
                  <a target="__blank" href="https://www.facebook.com/Onsportchannel/">
                    {faceBook}
                  </a>
                </div>
                <div className="cursor-pointer">
                  <a href="https://www.youtube.com/channel/UCIWo7q6irZUBaoPOrlf5IVw" target="__blank">
                    {youtube}
                  </a>
                </div>
                <div className="mt-2">
                  <a href="http://online.gov.vn/Home/WebDetails/88056" target="__blank" className="hidden md:block">
                    <Image
                      src="https://stvinaprod.vtvcab.vn/cae45c4d-9603-4048-adf7-fce15291cb88.png"
                      width={100}
                      height={38}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-span-4 flex flex-col justify-between">
              <div className="mt-4 sm:mt-0 text-sm md:flex justify-end">
                <div className="">
                  <div className="mb-2">Tải ứng dụng tại:</div>
                  <div className="md:flex">
                    <div className="mr-4 hidden md:flex">
                      <span style={{ width: 89, height: 80 }}>{QrcodeOnlus}</span>
                    </div>
                    <div className="flex md:block">
                      <div className="mb-3 mr-6 md:mr-0">
                        <a
                          href="https://apps.apple.com/vn/app/on-sports/id1282845933#?platform=iphone"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Image
                            src="https://stvinaprod.vtvcab.vn/91af4b21-6541-4aac-b557-eedde81a0f0a.png"
                            width={121}
                            height={35}
                          />
                        </a>
                      </div>
                      <div>
                        <div style={{ height: 35 }}>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.vtvcab.onsports"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Image
                              src="https://stvinaprod.vtvcab.vn/3c3bd6a8-bf15-48ab-9bcb-ec12ced5598e.png"
                              width={121}
                              height={35}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
const DfAvatar = (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.8496 2.66666C13.3274 2.71158 9.96201 4.13075 7.47119 6.62157C4.98038 9.11238 3.5612 12.4777 3.51628 16C3.53275 18.0519 4.02258 20.0723 4.94763 21.9039C5.87268 23.7355 7.208 25.3289 8.84961 26.56V26.6667H8.98295C11.2405 28.3966 14.0054 29.3342 16.8496 29.3342C19.6938 29.3342 22.4587 28.3966 24.7163 26.6667H24.8496V26.56C26.4912 25.3289 27.8265 23.7355 28.7516 21.9039C29.6767 20.0723 30.1665 18.0519 30.1829 16C30.138 12.4777 28.7189 9.11238 26.228 6.62157C23.7372 4.13075 20.3719 2.71158 16.8496 2.66666V2.66666ZM11.6096 25.24C11.8043 24.3486 12.2978 23.5505 13.0084 22.9782C13.719 22.4058 14.6039 22.0936 15.5163 22.0933H18.1829C19.0954 22.0936 19.9803 22.4058 20.6908 22.9782C21.4014 23.5505 21.895 24.3486 22.0896 25.24C20.5014 26.1744 18.6923 26.6671 16.8496 26.6671C15.0069 26.6671 13.1978 26.1744 11.6096 25.24V25.24ZM24.3296 23.52C23.8225 22.3079 22.9684 21.2727 21.8748 20.5445C20.7813 19.8162 19.4968 19.4273 18.1829 19.4267H15.5163C14.2024 19.4273 12.918 19.8162 11.8244 20.5445C10.7308 21.2727 9.87678 22.3079 9.36961 23.52C8.3705 22.5373 7.57482 21.3674 7.02803 20.0771C6.48125 18.7868 6.19408 17.4013 6.18295 16C6.21753 13.1818 7.35244 10.4887 9.34538 8.49576C11.3383 6.50282 14.0314 5.36791 16.8496 5.33332C19.6678 5.36791 22.3609 6.50282 24.3538 8.49576C26.3468 10.4887 27.4817 13.1818 27.5163 16C27.5051 17.4013 27.218 18.7868 26.6712 20.0771C26.1244 21.3674 25.3287 22.5373 24.3296 23.52V23.52Z"
      fill="white"
      fillOpacity="0.38"
    />
    <path
      d="M16.8496 8.00001C16.1447 7.98359 15.4439 8.11032 14.7894 8.37253C14.1349 8.63474 13.5404 9.02699 13.0418 9.52555C12.5433 10.0241 12.151 10.6186 11.8888 11.2731C11.6266 11.9276 11.4999 12.6285 11.5163 13.3333C11.4999 14.0382 11.6266 14.7391 11.8888 15.3936C12.151 16.0481 12.5433 16.6426 13.0418 17.1411C13.5404 17.6397 14.1349 18.0319 14.7894 18.2942C15.4439 18.5564 16.1447 18.6831 16.8496 18.6667C17.5545 18.6831 18.2554 18.5564 18.9099 18.2942C19.5643 18.0319 20.1589 17.6397 20.6574 17.1411C21.156 16.6426 21.5482 16.0481 21.8104 15.3936C22.0726 14.7391 22.1994 14.0382 22.1829 13.3333C22.1994 12.6285 22.0726 11.9276 21.8104 11.2731C21.5482 10.6186 21.156 10.0241 20.6574 9.52555C20.1589 9.02699 19.5643 8.63474 18.9099 8.37253C18.2554 8.11032 17.5545 7.98359 16.8496 8.00001V8.00001ZM16.8496 16C16.4949 16.0172 16.1405 15.9599 15.8092 15.832C15.4779 15.704 15.177 15.5082 14.9259 15.2571C14.6747 15.006 14.4789 14.7051 14.351 14.3738C14.223 14.0425 14.1658 13.6881 14.1829 13.3333C14.1658 12.9786 14.223 12.6242 14.351 12.2929C14.4789 11.9616 14.6747 11.6607 14.9259 11.4096C15.177 11.1585 15.4779 10.9627 15.8092 10.8347C16.1405 10.7068 16.4949 10.6495 16.8496 10.6667C17.2043 10.6495 17.5587 10.7068 17.89 10.8347C18.2213 10.9627 18.5222 11.1585 18.7733 11.4096C19.0245 11.6607 19.2203 11.9616 19.3482 12.2929C19.4762 12.6242 19.5334 12.9786 19.5163 13.3333C19.5334 13.6881 19.4762 14.0425 19.3482 14.3738C19.2203 14.7051 19.0245 15.006 18.7733 15.2571C18.5222 15.5082 18.2213 15.704 17.89 15.832C17.5587 15.9599 17.2043 16.0172 16.8496 16Z"
      fill="white"
      fillOpacity="0.38"
    />
  </svg>
)
const login = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 3.33331C17.8113 3.33331 15.6441 3.76441 13.622 4.60199C11.5999 5.43957 9.76257 6.66722 8.21493 8.21487C5.08932 11.3405 3.33337 15.5797 3.33337 20C3.33337 24.4203 5.08932 28.6595 8.21493 31.7851C9.76257 33.3327 11.5999 34.5604 13.622 35.398C15.6441 36.2356 17.8113 36.6666 20 36.6666C24.4203 36.6666 28.6595 34.9107 31.7852 31.7851C34.9108 28.6595 36.6667 24.4203 36.6667 20C36.6667 17.8113 36.2356 15.644 35.398 13.6219C34.5605 11.5998 33.3328 9.76251 31.7852 8.21487C30.2375 6.66722 28.4002 5.43957 26.3781 4.60199C24.356 3.76441 22.1887 3.33331 20 3.33331ZM11.7834 30.4666C12.5 28.9666 16.8667 27.5 20 27.5C23.1334 27.5 27.5 28.9666 28.2167 30.4666C25.95 32.2666 23.1 33.3333 20 33.3333C16.9 33.3333 14.05 32.2666 11.7834 30.4666ZM30.6 28.05C28.2167 25.15 22.4334 24.1666 20 24.1666C17.5667 24.1666 11.7834 25.15 9.40004 28.05C7.70004 25.8333 6.66671 23.0333 6.66671 20C6.66671 12.65 12.65 6.66665 20 6.66665C27.35 6.66665 33.3334 12.65 33.3334 20C33.3334 23.0333 32.3 25.8333 30.6 28.05ZM20 9.99998C16.7667 9.99998 14.1667 12.6 14.1667 15.8333C14.1667 19.0666 16.7667 21.6666 20 21.6666C23.2334 21.6666 25.8334 19.0666 25.8334 15.8333C25.8334 12.6 23.2334 9.99998 20 9.99998ZM20 18.3333C19.337 18.3333 18.7011 18.0699 18.2323 17.6011C17.7634 17.1322 17.5 16.4964 17.5 15.8333C17.5 15.1703 17.7634 14.5344 18.2323 14.0655C18.7011 13.5967 19.337 13.3333 20 13.3333C20.6631 13.3333 21.299 13.5967 21.7678 14.0655C22.2367 14.5344 22.5 15.1703 22.5 15.8333C22.5 16.4964 22.2367 17.1322 21.7678 17.6011C21.299 18.0699 20.6631 18.3333 20 18.3333Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)
const faceBook = (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
      fill="#B3B3B3"
    />
    <path
      d="M12.9315 17.998V12.534H14.7749L15.0489 10.3947H12.9315V9.03199C12.9315 8.41466 13.1035 7.99199 13.9895 7.99199H15.1122V6.08466C14.5659 6.02612 14.0169 5.99785 13.4675 5.99999C11.8382 5.99999 10.7195 6.99466 10.7195 8.82066V10.3907H8.88818V12.53H10.7235V17.998H12.9315Z"
      fill="#B3B3B3"
    />
  </svg>
)

const youtube = (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0009 7.87464C17.5517 8.02577 17.9854 8.47108 18.1326 9.03659C18.4001 10.0615 18.4001 12.2 18.4001 12.2C18.4001 12.2 18.4001 14.3384 18.1326 15.3634C17.9854 15.9289 17.5517 16.3742 17.0009 16.5254C16.0028 16.8 12.0001 16.8 12.0001 16.8C12.0001 16.8 7.99741 16.8 6.99923 16.5254C6.44846 16.3742 6.01472 15.9289 5.86752 15.3634C5.6001 14.3384 5.6001 12.2 5.6001 12.2C5.6001 12.2 5.6001 10.0615 5.86752 9.03659C6.01472 8.47108 6.44846 8.02577 6.99923 7.87464C7.99741 7.59998 12.0001 7.59998 12.0001 7.59998C12.0001 7.59998 16.0028 7.59998 17.0009 7.87464ZM10.8001 10.3999V14.3999L14.0001 12.4L10.8001 10.3999Z"
      fill="#B3B3B3"
    />
  </svg>
)
